import './RoomsBanner.scoped.scss';
import { useRecoilState } from "recoil";
import { useEffect } from "react";
import emitGetMyInfo from "../connector/emits/getMyInfo";
import roomsState from "../atoms/rooms";
import emitGetRooms from "../connector/emits/getRooms";
import myInfoState from "../atoms/myinfo";
import moment from "moment";

function RoomsBanner() {
  const [myInfo] = useRecoilState(myInfoState);
  const [rooms] = useRecoilState(roomsState);

  let sortedRooms = rooms.filter((room) => room.id !== '' && room.id !== 'square');
  sortedRooms.sort((a, b) => b.participants - a.participants);
  const slicedRooms = sortedRooms.slice(0, 10);

  useEffect(() => {
    emitGetMyInfo();
    emitGetRooms();
  }, []);

  const enterRoom = (roomId: string, isSecret: boolean) => {
    if (isSecret) {
      window.alert('비밀방은 채팅 대기실을 통해 입장해주세요.');
    } else {
      if (myInfo.userDetail?.id == null || myInfo.userDetail?.id === '') {
        window.alert('로그인 후 이용해주세요.');
      } else {
        window.open(
          `/chatting-app/room/${roomId}`, 
          'Room', 
          'width=940px,height=640px,status=no,scrollbars=no,toolbar=no'
        );
      }
    }
  }

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);

  return (
    <div className="rooms-banner">
      {slicedRooms.map((room, index) => {
        const thumbnailUrl = room.ownerDetail.hasThumbnail
        ? `/data/member_image/${room.owner.substring(0, 2)}/${room.owner}.gif?${thumbnailUrlTailer}`
        : '/img/profile.png';
        return (
          <button
            key={index}
            onClick={() => enterRoom(room.id, room.isSecret)}
          >
            <img
              src={thumbnailUrl}
              alt=""
            />
          </button>
        );
      })}
    </div>
  );
}

export default RoomsBanner;
